import { render, staticRenderFns } from "./BoothChat.vue?vue&type=template&id=2726650d&scoped=true&"
import script from "./BoothChat.vue?vue&type=script&lang=js&"
export * from "./BoothChat.vue?vue&type=script&lang=js&"
import style0 from "./BoothChat.vue?vue&type=style&index=0&id=2726650d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726650d",
  null
  
)

export default component.exports